(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
       document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.show-all-btn').forEach(function(button) {
        button.addEventListener('click', function() {
          var collectionId = this.getAttribute('data-collection-id');
          var collectionBlock = document.getElementById('collection-' + collectionId);
          var hiddenCards = collectionBlock.querySelectorAll('.collection-content-card.hide');
          var btnWrapper = collectionBlock.querySelector('.view-more-wrapper');

          hiddenCards.forEach(function(card) {
            card.classList.remove('hide');
          });

          btnWrapper.style.display = 'none'; // Hide the button after showing all cards
        });
      });
      var contentWrapper = document.getElementById('content_wrapper');
      var categoryDesc = document.getElementById('categoryDesc');

    if (contentWrapper.offsetHeight < 100) {
        contentWrapper.classList.add('d-none');
        categoryDesc.classList.remove('d-none');
      }
    });
    document.querySelector('.read-more-btn').addEventListener('click', function() {
      document.querySelectorAll('.collection-content-block').forEach(function(element) {
          element.classList.remove('d-none');
      });
      document.querySelector('.read-more-wrapper').classList.add('d-none');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-collection-v2"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product_options').forEach(radio => {
    radio.addEventListener('change', (event) => {
      if (event.target.checked) {
        const selectedRadio = event.target;
        const variantId = selectedRadio.dataset.variantId;
        const productUrl = selectedRadio.dataset.productUrl;
        console.log("product-title", productUrl);
        const productCard = selectedRadio.closest('.product-item');

        if (productCard) {
          // Update all href attributes with the new variant ID
          const imgWrapper = productCard.querySelector('.variant-img-wrapper');
          const titleWrapper = productCard.querySelector('.variant-title-wrapper');
          // const cartWrapper = productCard.querySelector('.variant-cart-wrapper');

          if (imgWrapper) {
            imgWrapper.href = `${productUrl}?variant=${variantId}`;
          }
          if (titleWrapper) {
            titleWrapper.href = `${productUrl}?variant=${variantId}`;
          }
          // if (cartWrapper) {
          //   cartWrapper.href = `${productUrl}?variant=${variantId}`;
          // }

          // Update other elements like price, compare price, and image
          const selectedPrice = parseFloat(selectedRadio.dataset.price.replace('$', ''));
          const selectedComparePrice = parseFloat(selectedRadio.dataset.comparePrice.replace('$', ''));
          const selectedImage = selectedRadio.dataset.img;

          const priceElement = productCard.querySelector('.product-variant-price');
          if (priceElement) {
            priceElement.textContent = `$${selectedPrice.toFixed(2)}`;
          }

          const comparePriceElement = productCard.querySelector('.product-variant-compare-price');
          if (comparePriceElement) {
            if (selectedComparePrice > selectedPrice) {
              comparePriceElement.textContent = `$${selectedComparePrice.toFixed(2)}`;
              comparePriceElement.style.display = 'inline';
            } else {
              comparePriceElement.style.display = 'none';
            }
          }

          const imageElement = productCard.querySelector('.product-variant-img');
          if (imageElement) {
            imageElement.src = selectedImage;
          }
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-collection"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('product_filter').addEventListener('click', function() {
    window.location.href = '/search';
});

  // document.getElementById('filter_button').addEventListener('click', function() {
  //   filterProducts();
  // });

  // document.getElementById('product_filter').addEventListener('input', function() {
  //   if (this.value === '') {
  //     showAllProducts();
  //   }
  // });

  // function filterProducts() {
  //   let visibleCount = 0;
  //   const slickTrack = document.querySelector('.slick-track');
  //   const filterValue = document.getElementById('product_filter').value.toLowerCase();
  //   const activeTab = document.querySelector('.tab-pane.active');
  //   const products = activeTab.querySelectorAll('.product-item');

  //   products.forEach(function(product) {
  //     const productTitle = product.querySelector('.product-title').innerText.toLowerCase();
  //     if (productTitle.includes(filterValue)) {
  //       product.style.display = 'block';
  //       visibleCount++;
  //     } else {
  //       product.style.display = 'none';
  //     }
  //   });
  //   console.log(slickTrack);
  //   slickTrack.style.setProperty('max-width', 250*visibleCount + 'px', 'important');
  // }

  // function showAllProducts() {
  //   const activeTab = document.querySelector('.tab-pane.active');
  //   const products = activeTab.querySelectorAll('.product-item');

  //   products.forEach(function(product) {
  //     product.style.display = 'block';
  //   });
  // }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-product"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const sizeChartButton = document.querySelector('.size-chart-button');
      if (sizeChartButton) {
        sizeChartButton.addEventListener('click', function(e) {
          e.preventDefault();
          const sizeChartSection = document.getElementById('size-chart-section');

          if (sizeChartSection) {
            sizeChartSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
      const scrollToReviewsLinks = document.querySelectorAll('.scroll-to-reviews');

      if (scrollToReviewsLinks) {
          scrollToReviewsLinks.forEach(function(link) {
              link.addEventListener('click', function(event) {
                  event.preventDefault();

                  const reviewsSection = document.getElementById('product-reviews-section');
                  if (reviewsSection) {
                      reviewsSection.scrollIntoView({
                          behavior: 'smooth',
                          block: 'start'
                      });
                  }
              });
          });
      }
    });


    $(document).ready(function() {
      $('#toggle-button').on('click', function() {
          var button = $(this);
          var items = $('.product-media-item');
          var images = $('.product--media');
          if (button.text() == "Show Less") {
              items.removeClass('d-none');
              images.removeClass('d-none');
              button.text("Show Less");
          } else {
              items.addClass('d-none');
              images.addClass('d-none');
              button.text("Show More");
          }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-tab-collections"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product_options').forEach(radio => {
    radio.addEventListener('change', (event) => {
      if (event.target.checked) {
        const selectedRadio = event.target;
        const variantId = selectedRadio.dataset.variantId;
        const productUrl = selectedRadio.dataset.productUrl;
        console.log("product-title", productUrl);
        const productCard = selectedRadio.closest('.product-item');

        if (productCard) {
          // Update all href attributes with the new variant ID
          const imgWrapper = productCard.querySelector('.variant-img-wrapper');
          const titleWrapper = productCard.querySelector('.variant-title-wrapper');
          // const cartWrapper = productCard.querySelector('.variant-cart-wrapper');

          if (imgWrapper) {
            imgWrapper.href = `${productUrl}?variant=${variantId}`;
          }
          if (titleWrapper) {
            titleWrapper.href = `${productUrl}?variant=${variantId}`;
          }
          // if (cartWrapper) {
          //   cartWrapper.href = `${productUrl}?variant=${variantId}`;
          // }

          // Update other elements like price, compare price, and image
          const selectedPrice = parseFloat(selectedRadio.dataset.price.replace('$', ''));
          const selectedComparePrice = parseFloat(selectedRadio.dataset.comparePrice.replace('$', ''));
          const selectedImage = selectedRadio.dataset.img;

          const priceElement = productCard.querySelector('.product-variant-price');
          if (priceElement) {
            priceElement.textContent = `$${selectedPrice.toFixed(2)}`;
          }

          const comparePriceElement = productCard.querySelector('.product-variant-compare-price');
          if (comparePriceElement) {
            if (selectedComparePrice > selectedPrice) {
              comparePriceElement.textContent = `$${selectedComparePrice.toFixed(2)}`;
              comparePriceElement.style.display = 'inline';
            } else {
              comparePriceElement.style.display = 'none';
            }
          }

          const imageElement = productCard.querySelector('.product-variant-img');
          if (imageElement) {
            imageElement.src = selectedImage;
          }
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.instagram-slider-item');

    items.forEach(item => {
        const btn = item.querySelector('.instagram-slider-item-btn');
        const detail = item.querySelector('.post-detail');
  
        btn.addEventListener('click', function(e) {
            e.stopPropagation();

            const isTooltipVisible = detail.classList.contains('active');
              
            document.querySelectorAll('.post-detail').forEach(d => {
                d.classList.remove('active');
            });
          
            if(!isTooltipVisible) {
                detail.classList.add('active');
            }
        });
    
        item.addEventListener('click', function(e) {
            if(!e.target.closest('.instagram-slider-item-btn')) {
                detail.classList.remove('active');
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lander-main-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sizeChartButton = document.querySelector('.size-chart-button');
    if (sizeChartButton) {
      sizeChartButton.addEventListener('click', function(e) {
        e.preventDefault();
        const sizeChartSection = document.getElementById('size-chart-section');

        if (sizeChartSection) {
          sizeChartSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    const scrollToReviewsLinks = document.querySelectorAll('.scroll-to-reviews');

    if (scrollToReviewsLinks) {
        scrollToReviewsLinks.forEach(function(link) {
            link.addEventListener('click', function(event) {
                event.preventDefault();

                const reviewsSection = document.getElementById('product-reviews-section');
                if (reviewsSection) {
                    reviewsSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }
  });

  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lander-related-product"] && !Shopify.designMode) return;
  try {
    
  $(".lander-related-product-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<img style="width:28px; height:28px; left: 15px;z-index:9;" class="slick-arrow slick-prev" src="https://cdn.shopify.com/s/files/1/2010/1493/files/left-arrow-black.svg?v=1695184456"/>',
      nextArrow: '<img style="width:28px; height:28px; right: 15px;z-index:9;" class="slick-arrow slick-next" src="https://cdn.shopify.com/s/files/1/2010/1493/files/right-arrow-black.svg?v=1695184456"/>',
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          },
        },
        {
          breakpoint: 578,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const sizeChartButton = document.querySelector('.size-chart-button');
      if (sizeChartButton) {
        sizeChartButton.addEventListener('click', function(e) {
          e.preventDefault();
          const sizeChartSection = document.getElementById('size-chart-section');

          if (sizeChartSection) {
            sizeChartSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
      const scrollToReviewsLinks = document.querySelectorAll('.scroll-to-reviews');

      if (scrollToReviewsLinks) {
          scrollToReviewsLinks.forEach(function(link) {
              link.addEventListener('click', function(event) {
                  event.preventDefault();

                  const reviewsSection = document.getElementById('product-reviews-section');
                  if (reviewsSection) {
                      reviewsSection.scrollIntoView({
                          behavior: 'smooth',
                          block: 'start'
                      });
                  }
              });
          });
      }
    });


    $(document).ready(function() {
      $('#toggle-button').on('click', function() {
          var button = $(this);
          var items = $('.product-media-item');
          var images = $('.product--media');
          if (button.text() == "Show Less") {
              items.removeClass('d-none');
              images.removeClass('d-none');
              button.text("Show Less");
          } else {
              items.addClass('d-none');
              images.addClass('d-none');
              button.text("Show More");
          }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sizeChartButton = document.querySelector('.size-chart-button');
    if (sizeChartButton) {
      sizeChartButton.addEventListener('click', function(e) {
        e.preventDefault();
        const sizeChartSection = document.getElementById('size-chart-section');

        if (sizeChartSection) {
          sizeChartSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    const scrollToReviewsLinks = document.querySelectorAll('.scroll-to-reviews');

    if (scrollToReviewsLinks) {
        scrollToReviewsLinks.forEach(function(link) {
            link.addEventListener('click', function(event) {
                event.preventDefault();

                const reviewsSection = document.getElementById('product-reviews-section');
                if (reviewsSection) {
                    reviewsSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.product-faqs-item');

    faqItems.forEach(item => {
      item.addEventListener('toggle', function() {
        if (item.open) {
          faqItems.forEach(otherItem => {
            if (otherItem !== item && otherItem.open) {
              otherItem.removeAttribute('open');
            }
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const sizeChartButton = document.querySelector('.size-chart-button');
      if (sizeChartButton) {
        sizeChartButton.addEventListener('click', function(e) {
          e.preventDefault();
          const sizeChartSection = document.getElementById('size-chart-section');

          if (sizeChartSection) {
            sizeChartSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
      const scrollToReviewsLinks = document.querySelectorAll('.scroll-to-reviews');

      if (scrollToReviewsLinks) {
          scrollToReviewsLinks.forEach(function(link) {
              link.addEventListener('click', function(event) {
                  event.preventDefault();

                  const reviewsSection = document.getElementById('product-reviews-section');
                  if (reviewsSection) {
                      reviewsSection.scrollIntoView({
                          behavior: 'smooth',
                          block: 'start'
                      });
                  }
              });
          });
      }
    });

    $(document).ready(function() {
    initslider(); // Initialize the slider on page load

    $(window).on('resize', function() {
      $('.product-info-slider-2').slick('unslick'); // Destroy the existing slider
      initslider(); // Reinitialize the slider on window resize
    });
  });

  function initslider() {
    $(".product-info-slider-2").slick({
      slidesToShow: 1,
      draggable: false,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      fade: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: true
          }
        },
        {
          breakpoint: 578,
          settings: {
            arrows: true,
            dots: true
          }
        }
      ]
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider-section-vb"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeaturedProductSwipers() {
      if (typeof Swiper === "undefined") {
        setTimeout(initFeaturedProductSwipers, 200);
        return;
      }

      document.querySelectorAll(".featured-product-slider.swiper").forEach(function (slider) {
        if (slider.swiper) {
          slider.swiper.update();
          slider.classList.add("is-slider-ready");
          return;
        }

        var swiper = new Swiper(slider, {
            mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              sensitivity: 1
          },

          simulateTouch: true,
          touchRatio: 1,
          touchAngle: 45,
          grabCursor: true,
          slidesPerView: 1.2,
          spaceBetween: 10,
          loop: false,
          slidesOffsetBefore: 30,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          breakpoints: {
            576: {
              slidesPerView: 2.1,
              spaceBetween: 10,
              slidesOffsetBefore: 30
            },
            992: {
              slidesPerView: 3.2,
              spaceBetween: 10,
              slidesOffsetBefore: 30
            },
            1200: {
              slidesPerView: 3.5,
              spaceBetween: 10,
              slidesOffsetBefore: 30
            },
            1600: {
              slidesPerView: 4.5,
              spaceBetween: 10,
              slidesOffsetBefore: 30
            }
          },
          on: {
            init: function () {
              var currentSwiper = this;

              requestAnimationFrame(function () {
                currentSwiper.update();
                slider.classList.add("is-slider-ready");
              });

              setTimeout(function () {
                currentSwiper.update();
                slider.classList.add("is-slider-ready");
              }, 300);
            }
          }
        });

        slider.querySelectorAll("img").forEach(function (img) {
          if (img.complete) {
            swiper.update();
            slider.classList.add("is-slider-ready");
            return;
          }

          img.addEventListener("load", function () {
            swiper.update();
            slider.classList.add("is-slider-ready");
          });
        });

        setTimeout(function () {
          swiper.update();
          slider.classList.add("is-slider-ready");
        }, 500);

        setTimeout(function () {
          swiper.update();
          slider.classList.add("is-slider-ready");
        }, 1000);
      });
    }

    function updateAllFeaturedProductSwipers() {
      document.querySelectorAll(".featured-product-slider.swiper").forEach(function (slider) {
        if (slider.swiper) {
          slider.swiper.update();
          slider.classList.add("is-slider-ready");
        }
      });
    }

    function bindTabUpdateEvents() {
      document.querySelectorAll('[data-bs-toggle="pill"]').forEach(function (tabButton) {
        if (tabButton.dataset.sliderTabBound === "true") return;

        tabButton.dataset.sliderTabBound = "true";

        tabButton.addEventListener("shown.bs.tab", function () {
          setTimeout(function () {
            document.querySelectorAll(".featured-product-slider.swiper").forEach(function (slider) {
              if (slider.swiper) {
                slider.swiper.update();
                slider.swiper.slideTo(0, 0);
                slider.classList.add("is-slider-ready");
              }
            });
          }, 150);
        });
      });
    }

    function bindVariantEvents() {
      document.querySelectorAll(".product_options").forEach(function (radio) {
        if (radio.dataset.variantBound === "true") return;

        radio.dataset.variantBound = "true";

        radio.addEventListener("change", function (event) {
          if (!event.target.checked) return;

          var selectedRadio = event.target;
          var variantId = selectedRadio.dataset.variantId;
          var productUrl = selectedRadio.dataset.productUrl;
          var productCard = selectedRadio.closest(".product-item");

          if (!productCard) return;

          var imgWrapper = productCard.querySelector(".variant-img-wrapper");
          var titleWrapper = productCard.querySelector(".variant-title-wrapper");

          if (imgWrapper && productUrl && variantId) {
            imgWrapper.href = productUrl + "?variant=" + variantId;
          }

          if (titleWrapper && productUrl && variantId) {
            titleWrapper.href = productUrl + "?variant=" + variantId;
          }

          var selectedPrice = parseFloat((selectedRadio.dataset.price || "0").replace("$", ""));
          var selectedComparePrice = parseFloat((selectedRadio.dataset.comparePrice || "0").replace("$", ""));
          var selectedImage = selectedRadio.dataset.img;

          var priceElement = productCard.querySelector(".product-variant-price");

          if (priceElement && !isNaN(selectedPrice)) {
            priceElement.textContent = "$" + selectedPrice.toFixed(2);
          }

          var comparePriceElement = productCard.querySelector(".product-variant-compare-price");

          if (comparePriceElement) {
            if (!isNaN(selectedComparePrice) && selectedComparePrice > selectedPrice) {
              comparePriceElement.textContent = "$" + selectedComparePrice.toFixed(2);
              comparePriceElement.style.display = "inline";
            } else {
              comparePriceElement.style.display = "none";
            }
          }

          var imageElement = productCard.querySelector(".product-variant-img");

          if (imageElement && selectedImage) {
            imageElement.src = selectedImage;

            imageElement.addEventListener("load", function () {
              var slider = productCard.closest(".featured-product-slider.swiper");

              if (slider && slider.swiper) {
                slider.swiper.update();
                slider.classList.add("is-slider-ready");
              }
            }, { once: true });
          }
        });
      });
    }

    function initSection() {
      initFeaturedProductSwipers();
      bindTabUpdateEvents();
      bindVariantEvents();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initSection);
    } else {
      initSection();
    }

    window.addEventListener("load", function () {
      initSection();
      updateAllFeaturedProductSwipers();

      setTimeout(updateAllFeaturedProductSwipers, 300);
      setTimeout(updateAllFeaturedProductSwipers, 800);
      setTimeout(updateAllFeaturedProductSwipers, 1200);
    });

    window.addEventListener("resize", function () {
      updateAllFeaturedProductSwipers();
    });

    document.addEventListener("shopify:section:load", function () {
      initSection();
      updateAllFeaturedProductSwipers();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeaturedProductSwipers() {
      if (typeof Swiper === "undefined") {
        setTimeout(initFeaturedProductSwipers, 200);
        return;
      }

      document.querySelectorAll(".featured-product-slider.swiper").forEach(function (slider) {
        if (slider.swiper) {
          slider.swiper.update();
          slider.classList.add("is-slider-ready");
          return;
        }

        var swiper = new Swiper(slider, {
            mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              sensitivity: 1
            },

          simulateTouch: true,
          touchRatio: 1,
          touchAngle: 45,
          grabCursor: true,
          slidesPerView: 1.2,
          spaceBetween: 10,
          loop: false,
          slidesOffsetBefore: 30,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          breakpoints: {
            576: {
              slidesPerView: 2.1,
              spaceBetween: 10,
              slidesOffsetBefore: 30
            },
            992: {
              slidesPerView: 3.2,
              spaceBetween: 10,
              slidesOffsetBefore: 30
            },
            1200: {
              slidesPerView: 3.5,
              spaceBetween: 10,
              slidesOffsetBefore: 30
            },
            1600: {
              slidesPerView: 4.5,
              spaceBetween: 10,
              slidesOffsetBefore: 30
            }
          },
          on: {
            init: function () {
              var currentSwiper = this;

              requestAnimationFrame(function () {
                currentSwiper.update();
                slider.classList.add("is-slider-ready");
              });

              setTimeout(function () {
                currentSwiper.update();
                slider.classList.add("is-slider-ready");
              }, 300);
            }
          }
        });

        slider.querySelectorAll("img").forEach(function (img) {
          if (img.complete) {
            swiper.update();
            slider.classList.add("is-slider-ready");
            return;
          }

          img.addEventListener("load", function () {
            swiper.update();
            slider.classList.add("is-slider-ready");
          });
        });

        setTimeout(function () {
          swiper.update();
          slider.classList.add("is-slider-ready");
        }, 500);

        setTimeout(function () {
          swiper.update();
          slider.classList.add("is-slider-ready");
        }, 1000);
      });
    }

    function updateAllFeaturedProductSwipers() {
      document.querySelectorAll(".featured-product-slider.swiper").forEach(function (slider) {
        if (slider.swiper) {
          slider.swiper.update();
          slider.classList.add("is-slider-ready");
        }
      });
    }

    function bindTabUpdateEvents() {
      document.querySelectorAll('[data-bs-toggle="pill"]').forEach(function (tabButton) {
        if (tabButton.dataset.sliderTabBound === "true") return;

        tabButton.dataset.sliderTabBound = "true";

        tabButton.addEventListener("shown.bs.tab", function () {
          setTimeout(function () {
            document.querySelectorAll(".featured-product-slider.swiper").forEach(function (slider) {
              if (slider.swiper) {
                slider.swiper.update();
                slider.swiper.slideTo(0, 0);
                slider.classList.add("is-slider-ready");
              }
            });
          }, 150);
        });
      });
    }

    function bindVariantEvents() {
      document.querySelectorAll(".product_options").forEach(function (radio) {
        if (radio.dataset.variantBound === "true") return;

        radio.dataset.variantBound = "true";

        radio.addEventListener("change", function (event) {
          if (!event.target.checked) return;

          var selectedRadio = event.target;
          var variantId = selectedRadio.dataset.variantId;
          var productUrl = selectedRadio.dataset.productUrl;
          var productCard = selectedRadio.closest(".product-item");

          if (!productCard) return;

          var imgWrapper = productCard.querySelector(".variant-img-wrapper");
          var titleWrapper = productCard.querySelector(".variant-title-wrapper");

          if (imgWrapper && productUrl && variantId) {
            imgWrapper.href = productUrl + "?variant=" + variantId;
          }

          if (titleWrapper && productUrl && variantId) {
            titleWrapper.href = productUrl + "?variant=" + variantId;
          }

          var selectedPrice = parseFloat((selectedRadio.dataset.price || "0").replace("$", ""));
          var selectedComparePrice = parseFloat((selectedRadio.dataset.comparePrice || "0").replace("$", ""));
          var selectedImage = selectedRadio.dataset.img;

          var priceElement = productCard.querySelector(".product-variant-price");

          if (priceElement && !isNaN(selectedPrice)) {
            priceElement.textContent = "$" + selectedPrice.toFixed(2);
          }

          var comparePriceElement = productCard.querySelector(".product-variant-compare-price");

          if (comparePriceElement) {
            if (!isNaN(selectedComparePrice) && selectedComparePrice > selectedPrice) {
              comparePriceElement.textContent = "$" + selectedComparePrice.toFixed(2);
              comparePriceElement.style.display = "inline";
            } else {
              comparePriceElement.style.display = "none";
            }
          }

          var imageElement = productCard.querySelector(".product-variant-img");

          if (imageElement && selectedImage) {
            imageElement.src = selectedImage;

            imageElement.addEventListener("load", function () {
              var slider = productCard.closest(".featured-product-slider.swiper");

              if (slider && slider.swiper) {
                slider.swiper.update();
                slider.classList.add("is-slider-ready");
              }
            }, { once: true });
          }
        });
      });
    }

    function initSection() {
      initFeaturedProductSwipers();
      bindTabUpdateEvents();
      bindVariantEvents();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initSection);
    } else {
      initSection();
    }

    window.addEventListener("load", function () {
      initSection();
      updateAllFeaturedProductSwipers();

      setTimeout(updateAllFeaturedProductSwipers, 300);
      setTimeout(updateAllFeaturedProductSwipers, 800);
      setTimeout(updateAllFeaturedProductSwipers, 1200);
    });

    window.addEventListener("resize", function () {
      updateAllFeaturedProductSwipers();
    });

    document.addEventListener("shopify:section:load", function () {
      initSection();
      updateAllFeaturedProductSwipers();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"] && !Shopify.designMode) return;
  try {
    
    function initslider() {
  $(".related-product-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<img style="width:28px; height:28px; left: 15px;z-index:99;" class="slick-arrow slick-prev" src="https://cdn.shopify.com/s/files/1/2010/1493/files/left-arrow-black.svg?v=1695184456"/>',
      nextArrow: '<img style="width:28px; height:28px; right: 15px;z-index:99;" class="slick-arrow slick-next" src="https://cdn.shopify.com/s/files/1/2010/1493/files/right-arrow-black.svg?v=1695184456"/>',
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          },
        },
        {
          breakpoint: 578,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    }
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const url = productRecommendationsSection.dataset.url;

     fetch(url)
       .then(response => response.text())
       .then(text => {
         const html = document.createElement('div');
         html.innerHTML = text;
         const recommendations = html.querySelector('.product-recommendations');

         if (recommendations && recommendations.innerHTML.trim().length) {
           productRecommendationsSection.innerHTML = recommendations.innerHTML;
           initslider();
         }
       })
       .catch(e => {
         console.error(e);
       });

  } catch(e) { console.error(e); }
})();
})();
